export enum AloePaymentNotificationStatus {
  SUCCESS = '200',
  ERROR = '400',
}
